import { render } from "./bagLayout.vue?vue&type=template&id=26b5e9db&scoped=true&ts=true"
import script from "./bagLayout.vue?vue&type=script&lang=ts"
export * from "./bagLayout.vue?vue&type=script&lang=ts"

import "./bagLayout.vue?vue&type=style&index=0&id=26b5e9db&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b5e9db"]])

export default __exports__